import { ITagResult } from '~src/httpClient/serverApi/types/IResponse';
import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { CustomDomainSettingResponse, GetCustomDomainSettingRequest } from '../types/CustomDomainTypes';


export class GetCustomDomainSettingTagRequest extends TagRequest<GetCustomDomainSettingRequest,  ICustomDomainSettingResult> {
    constructor(request: GetCustomDomainSettingRequest) {
      super('custom_domains_service', 'getSiteCustomDomainSettings', request);
    }
}

export type ICustomDomainSettingResult = ITagResult & CustomDomainSettingResponse;